import { lazy } from 'react'
import suspenseComponent from '../../../../../../../util/suspenseComponent'

// Containers
import RubberPurchasesMenuContainer from '../../../../../../../containers/dashboard/SystemRubber/RubberPurchases/containers/RubberPurchasesMenuContainer'

// Components
const PurchasesListContainer = lazy(() => import('../../../../../../../containers/dashboard/SystemRubber/RubberPurchases/containers/RubberPurchasesListContainer'))
const RubberPurchaseManagePage = lazy(() => import('../../../../../../../containers/dashboard/SystemRubber/RubberPurchases/pages/RubberPurchaseManagePage'))

const RubberPurchasesMenuRoutes = [
  {
    path: '/:username/rubber-purchases',
    component: RubberPurchasesMenuContainer,
    routes: [
      {
        path: '/:username/rubber-purchases/:reserve/:reserveStatus(all|estimate|finish)/:purchases_id',
        component: suspenseComponent(PurchasesListContainer),
        routes: [
          {
            path: '/:username/rubber-purchases/:reserve/:reserveStatus(all|estimate|finish)/:purchases_id',
            auth: { reqAuthBiz: true, reqExpDate: true },
            component: suspenseComponent(RubberPurchaseManagePage)
          },
        ]
      },
    ]
  }
  /*{
    path: '/:username/rubber-purchases',
    component: RubberPurchasesMenuContainer,
    routes: [
      {
        path: '/:username/rubber-purchases/:purchases_id',
        component: suspenseComponent(PurchasesListContainer),
        routes: [
          {
            path: '/:username/rubber-purchases/:purchases_id',
            auth: { reqAuthBiz: true, reqExpDate: true },
            component: suspenseComponent(RubberPurchaseManagePage)
          },
        ]
      },
    ]
  }*/
]

export default RubberPurchasesMenuRoutes
